import { ARM_NAME, BASE_NAME, BRACE_NAME, COLUMN_NAME } from "../components/CantileverPart";

// Warehouse staff identify a part by its dimensions, not by its row name - a bare
// "Column" describes forty different things. This builds the label they already read
// on the Products Report export, and lives here rather than inside one component so
// the stock history and that export can never drift into naming the same part
// differently.
//
// Takes a plain attributes object, not a Parse object, so it works on both a live
// record (part.attributes) and a decoded one.
export const formatPartLabel = (part) => {
  const name = part?.name || '';

  if (name === COLUMN_NAME) {
    const height = part.height || '';
    const width = part.width || '';
    return `${name} - ${height} High / ${width}`;
  }

  if (name === BASE_NAME) {
    const sides = part.sides === "1" ? 'S/S' : 'D/S';
    const armToSuitBase = part.armToSuitBase || '';

    let dutyValue;
    if (part.duty === 'Light') dutyValue = '200';
    else if (part.duty === 'Medium') dutyValue = '305';
    else if (part.duty === 'Heavy') dutyValue = '350';
    else dutyValue = '';

    const width = part.width || '';

    return `${name} - ${sides} for ${armToSuitBase} Arms / ${dutyValue} (${width})`;
  }

  if (name === ARM_NAME) {
    const height = part.height || '';
    const depth = part.depth || '';
    return `${name} - H${height}, ${depth}`;
  }

  if (name === BRACE_NAME) {
    const bayParts = (part.bayCenter || '').split(" ");
    const direction = bayParts.length >= 2 ? (bayParts[0] === "Horizontal" ? "H" : 'D') : '';
    const measurement = bayParts.length >= 2 ? (bayParts[1] || '') : '';
    const width = part.width || '';
    return `${name} - ${direction} ${measurement} c/c (${width})`;
  }

  // Pallet racking parts carry a single dimensions string instead of separate
  // height/width/depth fields, and it is what distinguishes one beam from another.
  const fallback = name || part?.description || part?.partID || 'Unnamed part';
  return part?.dimensions ? `${fallback} - ${part.dimensions}` : fallback;
};
